import { all } from 'redux-saga/effects';


const rootSaga = function* () {
    yield all([]);
};

export default rootSaga;
